import { ACTIONS, State } from './types';
import { Reducer } from 'react';

export const createInitialState = (data: any = [], isPending: boolean = true): State => ({
  data,
  pending: isPending,
  error: '',
  axiosError: null,
  loaded: false,
});

export const reducer: Reducer<State, any> = (state: State, action: any) => {
  const map: Map<ACTIONS, () => State> = new Map([
    [
      ACTIONS.START,
      () => ({
        ...state,
        pending: true,
      }),
    ],
    [
      ACTIONS.SUCCESS,
      () => ({
        ...state,
        pending: false,
        data: action.payload,
        error: '',
        axiosError: null,
        loaded: true,
      }),
    ],
    [
      ACTIONS.ERROR,
      () => ({
        ...state,
        pending: false,
        loaded: true,
        axiosError: action.payload[1],
        error: action.payload[0],
      }),
    ],
    [ACTIONS.DEFAULT, () => state],
    [ACTIONS.RESET, () => action.payload],
  ]);
  const actionExecutor = map.get(action.type) || (() => state);
  return actionExecutor();
};
